import React, { useState, useEffect } from 'react';
import { Alert, Button, Col, Modal, Row, Table } from 'antd';
import {
  useAuth,
  useGetCourseStudentsSociogram,
  useGetSurveysSociogram,
  useSendActivationSurvey,
} from '@BUP/hooks';
import { BupSpinner } from '@BUP/components';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import styles from './table-students.module.css';

const TableStudentsData = ({ hasSelection }) => {
  const history = useHistory();
  const { user } = useAuth();
  const { isLoadingStudents, studentsList } = useGetCourseStudentsSociogram(
    user
  );
  const { isLoadingSurveySociogram, surveySociogram } = useGetSurveysSociogram(
    user
  );
  const {
    updateSurveySociogram,
    dataResponseSurvey,
    errorResponseSurvey,
  } = useSendActivationSurvey(surveySociogram);
  const [isModalVisible, setIsModalVisible] = useState(false);

  const [selectedRowKeys, setSelectedRowKeys] = useState([]);

  const [t] = useTranslation();

  // Data tabla
  const columns = [
    {
      title: (
        <strong className={styles.header_table}>
          {t('pages.data.instruments.activateStudentTableheader1')}
        </strong>
      ),
      dataIndex: 'name',
    },
    {
      title: (
        <strong className={styles.header_table}>
          {t('pages.data.instruments.activateStudentTableheader2')}
        </strong>
      ),
      dataIndex: 'email',
      columnWidth: '100px',
    },
  ];

  const dataStudentsTable = studentsList?.map((student, index) => ({
    key: student?.enrollments[0]?.id,
    name: `${index + 1}. ${student?.name}`,
    email: student?.email,
  }));

  const arrayParticipants = dataStudentsTable?.map((student) => {
    return student?.key;
  });

  useEffect(() => {
    setSelectedRowKeys(arrayParticipants);
  }, [studentsList]);

  const onSelectChange = (participants) => {
    setSelectedRowKeys(participants || []);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  // Funciones para controlar modal
  const showModal = () => {
    setIsModalVisible(true);
  };
  const handleOk = () => {
    setIsModalVisible(false);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const handleClickActiveSurvey = async () => {
    const studentsId = dataStudentsTable?.map((student) => student.key);

    const nonParticipants = studentsId?.filter((item) => {
      return !selectedRowKeys.includes(item);
    });

    await updateSurveySociogram({
      data: {
        isActive: true,
        participants: selectedRowKeys,
        nonParticipants,
      },
    });

    setIsModalVisible(false);
  };

  return (
    <>
      {isLoadingStudents || isLoadingSurveySociogram ? (
        <BupSpinner size="large" />
      ) : (
        <>
          {!hasSelection ? (
            <p style={{ marginBottom: 8 }}>
              {t('pages.data.instruments.totalStudents')}{' '}
              <span className={styles.students_number}>
                {dataStudentsTable?.length}
              </span>
            </p>
          ) : (
            <p style={{ marginLeft: 8 }}>
              {t('pages.data.instruments.studentSelected')}{' '}
              <span className={styles.students_number}>
                {selectedRowKeys?.length}
              </span>{' '}
              <span>{t('pages.data.instruments.studentTag')}</span>
            </p>
          )}
          <Table
            rowSelection={hasSelection ? rowSelection : null}
            columns={columns}
            dataSource={dataStudentsTable}
            pagination={{
              position: ['bottomCenter'],
              defaultPageSize: 10,
              showSizeChanger: true,
              pageSizeOptions: ['10', '20', '30'],
            }}
          />
          {hasSelection ? (
            <>
              <Row justify="end">
                {dataResponseSurvey || surveySociogram?.isActive ? (
                  <>
                    <Col span={18}>
                      <Alert
                        message={t('pages.data.instruments.successMessage1')}
                        type="success"
                        showIcon
                        closable
                      />
                    </Col>

                    <Col span={4}>
                      <Button
                        className={styles.back_button}
                        type="primary"
                        onClick={() => history.goBack()}
                      >
                        {t('pages.data.instruments.button1')}
                      </Button>
                    </Col>
                  </>
                ) : errorResponseSurvey ? (
                  <>
                    <Col span={18}>
                      <Alert
                        message={t('pages.data.instruments.errorMessage')}
                        type="error"
                        showIcon
                        closable
                      />
                    </Col>

                    <Col span={4}>
                      <Button
                        className={styles.activation_button2}
                        type="primary"
                        onClick={showModal}
                        disabled={!selectedRowKeys.length}
                      >
                        {t('pages.data.instruments.sentButton')}
                      </Button>
                    </Col>
                  </>
                ) : (
                  <Col>
                    <Button
                      className={styles.activation_button1}
                      type="primary"
                      onClick={showModal}
                      disabled={!selectedRowKeys.length}
                    >
                      {t('pages.data.instruments.sentButton')}
                    </Button>
                  </Col>
                )}
              </Row>
              <Modal
                title={t('pages.data.instruments.modalTitle')}
                visible={isModalVisible}
                onOk={handleOk}
                onCancel={handleCancel}
                footer={[
                  <Row align="space-evenly">
                    <Col span={10}>
                      <Button
                        className={styles.cancel_button}
                        type="primary"
                        onClick={handleCancel}
                      >
                        {t('pages.data.instruments.cancelbutton')}
                      </Button>
                    </Col>
                    <Col span={10}>
                      <Button
                        className={styles.confirm_button}
                        type="primary"
                        onClick={() => handleClickActiveSurvey(selectedRowKeys)}
                      >
                        {t('pages.data.instruments.confirmMessage')}
                      </Button>
                    </Col>
                  </Row>,
                ]}
              >
                <Row align="center">
                  <Col>
                    <p>{t('pages.data.instruments.questionMessage')}</p>
                  </Col>
                </Row>
              </Modal>
            </>
          ) : null}
        </>
      )}
    </>
  );
};

export default TableStudentsData;
